import React, { useState } from 'react';
import './PurchaseTokens.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
//icons
import backIcon from '../../../../assets/iconBack.png';
import iconNewCard from '../../../../assets/iconNewcard.png';
import iconPaypal from '../../../../assets/iconPayPal.png';
//Components
import PackageCard from '../../../../components/PackageCard/PackageCard';
import PaymentMethodButton from '../../../../components/PaymentMethodButton/PaymentMethodButton';
import SavedCardsModal from '../../../../components/SavedCardsModal/SavedCardsModal';
//services
import { paymentService } from '../../../../services/Payment';

const PurchaseTokens = ({ onBack, selectedPackage, token, paymentMethods = [], responsePurchase }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const paymentOptions = [
    { 
      id: 'card', 
      name: t('packages.newCard'),
      icon: <img src={iconNewCard} alt="New card" className="payment-icon" />,
    },
    /*{ 
      id: 'paypal', 
      name: 'PayPal',
      icon: <img src={iconPaypal} alt="PayPal" className="payment-icon" />
    },*/
  ];

  const handlePay = async () => {
    try {
      if(paymentMethods.length === 0) {
        responsePurchase("errorNoPaymentMethod");
        return;
      }

      let paymentMethodId = '';
      paymentMethods.forEach((method) => {
        if(method.is_default) {
          paymentMethodId = method.id;
        }
      });
      
      const response = await paymentService.purchasePackage(token, selectedPackage.id);
      if (response.status === 201) {
        const responseIntent = await paymentService.confirmPaymentIntent(paymentMethodId, response.data.payment_intent_id);
        if (responseIntent.status === "succeeded") {
          responsePurchase("");
        }else{
          console.log('Payment failed');
          responsePurchase("errorPurchase");
        }
      }else{
        console.log('Payment failed');
        responsePurchase("errorPurchase");
      }
    } catch (error) {
      console.error('Error creating payment:', error);
      responsePurchase("errorPurchase");
    }
  };

  const handleOption = (option) => {
    const language = i18n.language;
    console.log(language);
    if(option === 'card') {
      navigate(`/payments/payment-method/${token}/${language}`, { state: { onBack: true } });
    }
  };

  const handleDefaultPayment = async (paymentMethodId) => {
    try {
      const dataUser = await paymentService.getDataUser(token);
      console.log(dataUser);
      if(dataUser.status === "success"){
        const response = await paymentService.setDefaultPaymentMethod(paymentMethodId, dataUser.data.id, token);
        if (response.status === "success") {
          responsePurchase("successDefaultPayment");
        }else{
          console.log('Payment failed');
          responsePurchase("errorDefaultPayment");
        }
      }else{
        console.log('Payment failed');
        responsePurchase("errorDefaultPayment");
      }
    } catch (error) {
      console.error('Error creating payment:', error);
      responsePurchase("errorDefaultPayment");
    }
  };

  return (
    <div className="purchase-tokens">
      <div className="purchase-header">
        <button className="back-button" onClick={onBack}>
          <img src={backIcon} alt="Back" className="back-icon" />
          {t('packages.packages')}
        </button>
      </div>

      <div className="selected-package">
        <PackageCard 
          id={selectedPackage?.id} 
          tokens={selectedPackage?.tokens} 
          price={selectedPackage?.price} 
          originalPrice={selectedPackage?.originalPrice}
          onPurchase={false}
          fullWidth={true}
        />
      </div>

      {paymentMethods.length > 0 && (
        <div className="payment-section">
          <h2 className="payment-title">{t('packages.saved')}</h2>
          {paymentMethods.filter((method) => (method.is_default)).map((method) => (
            <PaymentMethodButton
              key={method.id}
              method={method}
              isSelected={selectedMethod === method.id}
              more={true}
              onClickMore={() => setIsModalOpen(true)}
            />
          ))}
          <SavedCardsModal
            selectedCard={selectedCard}
            onSelectCard={(cardId) => {
              handleDefaultPayment(cardId);
              setIsModalOpen(false);
            }}
            savedCards={paymentMethods}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </div>
      )}

      <div className="payment-section">
        <h2 className="payment-title">{t('packages.newPayment')}</h2>
        
        <div className="payment-methods">
          {paymentOptions.map((method) => (
            <PaymentMethodButton
              key={method.id}
              method={method}
              isSelected={selectedMethod === method.id}
              onClick={() => {
                handleOption(method.id)
              }}
            />
          ))}
        </div>
      </div>

      <button className="pay-button" onClick={handlePay}>
        {t('packages.buy')} ${selectedPackage?.price || '9.99'}
      </button>
    </div>
  );
};

export default PurchaseTokens;
